/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserPermissionsFormData,
    UserPermissionsFormDataFromJSON,
    UserPermissionsFormDataFromJSONTyped,
    UserPermissionsFormDataToJSON,
} from './';

/**
 * 
 * @export
 * @interface B2cUser
 */
export interface B2cUser {
    /**
     * 
     * @type {boolean}
     * @memberof B2cUser
     */
    accountEnabled?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof B2cUser
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cUser
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cUser
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cUser
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {UserPermissionsFormData}
     * @memberof B2cUser
     */
    permissions?: UserPermissionsFormData;
}

export function B2cUserFromJSON(json: any): B2cUser {
    return B2cUserFromJSONTyped(json, false);
}

export function B2cUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): B2cUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountEnabled': !exists(json, 'accountEnabled') ? undefined : json['accountEnabled'],
        'givenName': !exists(json, 'givenName') ? undefined : json['givenName'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'surname': !exists(json, 'surname') ? undefined : json['surname'],
        'emailAddress': !exists(json, 'emailAddress') ? undefined : json['emailAddress'],
        'permissions': !exists(json, 'permissions') ? undefined : UserPermissionsFormDataFromJSON(json['permissions']),
    };
}

export function B2cUserToJSON(value?: B2cUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accountEnabled': value.accountEnabled,
        'givenName': value.givenName,
        'id': value.id,
        'surname': value.surname,
        'emailAddress': value.emailAddress,
        'permissions': UserPermissionsFormDataToJSON(value.permissions),
    };
}


